import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { Category } from './Category/Category';
import { CategoriesPageWrapper } from './CategoriesPage.style';
import { PageHeader } from './PageHeader/PageHeader';
import { SearchAndFiltersCategories } from './SearchAndFilters/SearchAndFiltersCategories';
import { LiveGamesState } from 'src/domains/casino/state/AppCasino/live-games/LiveGames.state';

interface CategoriesPagePropsType {
    liveGamesState: LiveGamesState;
}

export const CategoriesPage = observer('CategoriesPage', ({ liveGamesState }: CategoriesPagePropsType) => {
    return (
        <div>
            <PageHeader
                pageTitle='Live Games'
                hasButton={true}
                onClick={liveGamesState.onAddNewCategory}
            />
            <SearchAndFiltersCategories liveGamesState={liveGamesState} />
            <CategoriesPageWrapper
                onDragOver={liveGamesState.onDragOver}
                onDrop={liveGamesState.onDrop}
                ref={liveGamesState.setLiveGamesRef}
                onScroll={liveGamesState.updateScrollValue}
                data-test='live-games-list'
            >
                {liveGamesState.categories.map((category) => (
                    <Category
                        key={category.id}
                        category={category}
                        liveGamesState={liveGamesState}
                    />
                ))}
            </CategoriesPageWrapper>
        </div>
    );
});
